const PanelContent = {
  baseStyle: {
    ms: 'auto',
    me: 'auto',
    ps: '16px',
    pe: '16px',
  },
};

export const PanelContentComponent = {
  components: {
    PanelContent,
  },
};
